import React from 'react';
import { Box, IconButton, Tooltip } from '@cad-arc';
import { WorkspacePanelDto } from '@mark43/cad-api';
import { useWorkspaceStore } from './use-workspace-store';
import { observer } from 'mobx-react-lite';
import { OnAddPanel, useOpenWorkspacePanel } from './use-open-workspace-panel';
import { usePanelsPermittedInWindow } from '../common/hooks/use-panels-permitted-in-window';
import { useNavigate } from 'react-router-dom';
import { QUEUES_WINDOW_PATH } from '../router/constants';
import { useApplicationType } from '../common/hooks/use-application-type';

type IconButtonProps = React.ComponentProps<typeof IconButton>;

export const WorkspacePanelButton = observer(function WorkspacePanelButton(props: {
    'aria-label': IconButtonProps['aria-label'];
    icon: IconButtonProps['icon'];
    tooltipText: React.ComponentProps<typeof Tooltip>['content'];
    workspacePanelType: WorkspacePanelDto['workspacePanelType'];
    onAddPanel?: OnAddPanel;
    shouldFocus?: boolean;
}): React.ReactElement {
    const { isWeb } = useApplicationType();
    const workspacePanelsStore = useWorkspaceStore();
    const existingPanel = workspacePanelsStore.activePanels.find(
        (p) => p.workspacePanelType === props.workspacePanelType
    );
    const openWorkspacePanel = useOpenWorkspacePanel();
    const panelsPermittedInWindow = usePanelsPermittedInWindow();
    const navigate = useNavigate();
    return (
        <Tooltip content={props.tooltipText} side="bottom">
            <Box
                h="100%"
                borderBottom={panelsPermittedInWindow && existingPanel ? '1px solid' : undefined}
                borderBottomColor="selected.default"
            >
                <IconButton
                    aria-label={props['aria-label']}
                    icon={props.icon}
                    variant="ghost"
                    onClick={() => {
                        if (!panelsPermittedInWindow && isWeb) {
                            navigate(QUEUES_WINDOW_PATH);
                        }
                        openWorkspacePanel({
                            workspacePanelConfig: {
                                workspacePanelType: props.workspacePanelType,
                            },
                            onAddPanel: props.onAddPanel,
                            shouldFocus: props.shouldFocus,
                        });
                    }}
                />
            </Box>
        </Tooltip>
    );
});
